import { render, staticRenderFns } from "./PrimaryLogoDisplay.vue?vue&type=template&id=1afb9328&scoped=true&"
import script from "./PrimaryLogoDisplay.vue?vue&type=script&lang=js&"
export * from "./PrimaryLogoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryLogoDisplay.vue?vue&type=style&index=0&id=1afb9328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afb9328",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VImg})
